export enum VIDEO_STATUS {
  PREPARING = 'preparing',
  REQUIRES_REVIEW = 'requires_review',
  PENDING_APPROVAL = 'pending_approval',
  CLIPPING_IN_PROGRESS = 'clipping_in_progress',
  UNAPPROVED = 'unapproved',
  APPROVED = 'approved',
  SOFT_DELETED = 'soft_deleted',
  ERRORED = 'errored',
}